import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Row,
  Col,
  CardHeader,
  Table,
  Badge,
} from "reactstrap";
import { formatRP } from "../../../Utils/externalFunctions";
import { toast } from "react-toastify";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkTableRow } from "../../../Utils/otherFunctions";
import {
  getAnggaranDipakaiRealokasiAnggaran,
  getAnggaranDipakaiRealokasiDokumen,
  getAnggaranRencImp,
} from "../services";
toast.configure();

const RincianRealokasi = ({
  isOpen,
  toggle,
  selectedRealokasi,
  axiosInstance,
}) => {
  const [anggaranDipakaiRealokasi, setAnggaranDipakaiRealokasi] = useState([]);
  const [rencanaImp, setRencanaImp] = useState([]);
  const [sisaRencImp, setSisaRencImp] = useState([]);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: anggaranRencImpData } = await getAnggaranRencImp(
        axiosInstance,
        selectedRealokasi.kd_rencana_implementasi
      );
      setSisaRencImp(anggaranRencImpData);

      const { data: anggaranDipakaiRealokasiDokumen } =
        await getAnggaranDipakaiRealokasiDokumen(
          axiosInstance,
          selectedRealokasi.id_realokasi
        );
      setRencanaImp(anggaranDipakaiRealokasiDokumen);

      const { data: anggaranDipakaiRealokasiAnggaran } =
        await getAnggaranDipakaiRealokasiAnggaran(
          axiosInstance,
          selectedRealokasi.id_realokasi
        );
      setAnggaranDipakaiRealokasi(anggaranDipakaiRealokasiAnggaran);
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, [selectedRealokasi]);

  const getAnggaranDigunakan = (pk) => {
    const anggaran = anggaranDipakaiRealokasi.find(
      (anggaran) => anggaran.rencana_imp === pk
    );
    return anggaran?.anggaran_digunakan || "Loading";
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Rincian Realokasi</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="12">
            <Form className="needs-validation">
              <Row className="justify-content-md-center">
                <h6>
                  <Badge color="success">Warna Hijau:</Badge> Anggaran akan
                  ditambahkan
                </h6>
                <h6>
                  <Badge color="danger">Warna Merah:</Badge> Anggaran akan
                  dikurangi
                </h6>
                <h6>
                  <Badge>
                    Realokasi ini{" "}
                    {selectedRealokasi.is_target === "t" ? "Target" : "Sumber"}
                  </Badge>
                </h6>
                <Col md="4">
                  <CardHeader className="pb-0 text-center mt-4">
                    <h2>
                      <strong>Rincian Realokasi</strong>
                    </h2>
                  </CardHeader>
                  <Table hover>
                    <tbody>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}></td>
                        <td className={getDarkTableRow(themeContext)}></td>
                      </tr>
                      <tr>
                        <td
                          className={
                            "align-center" + getDarkTableRow(themeContext)
                          }
                        >
                          <strong>DPSJ</strong>
                        </td>
                        <td
                          className={
                            "align-center" + getDarkTableRow(themeContext)
                          }
                        >
                          {selectedRealokasi.unit_kerja}
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Kegiatan</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          {selectedRealokasi.kd_keg} -{" "}
                          {selectedRealokasi.nm_keg}
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Akun</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          {selectedRealokasi.kd_akun} -{" "}
                          {selectedRealokasi.nm_akun}
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Sisa Anggaran</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          <p>
                            <Badge
                              color={
                                selectedRealokasi.is_target === "t"
                                  ? "danger"
                                  : "success"
                              }
                              pill
                            >
                              Rp.{" "}
                              {formatRP(sisaRencImp?.anggaran_tersisa) ||
                                "loading"}
                            </Badge>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Anggaran Realokasi</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          <Badge
                            color={
                              selectedRealokasi.is_target === "t"
                                ? "danger"
                                : "success"
                            }
                            pill
                          >
                            Rp. {formatRP(selectedRealokasi.nilai_anggaran)}
                          </Badge>
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Keterangan</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          {selectedRealokasi.keterangan}
                        </td>
                      </tr>
                      <tr>
                        <td className={getDarkTableRow(themeContext)}>
                          <strong>Alasan</strong>
                        </td>
                        <td className={getDarkTableRow(themeContext)}>
                          {selectedRealokasi.alasan}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <ModalBody></ModalBody>
        <Row>
          <Col sm="12">
            <Table responsive>
              <thead>
                <tr>
                  <th className={getDarkTableRow(themeContext)}>Kegiatan</th>
                  <th className={getDarkTableRow(themeContext)}>Akun</th>
                  <th className={getDarkTableRow(themeContext)}>
                    Sisa Anggaran (Rp)
                  </th>
                  <th className={getDarkTableRow(themeContext)}>
                    Jumlah Realokasi (Rp)
                  </th>
                </tr>
              </thead>
              <tbody>
                {rencanaImp.map((value) => (
                  <tr key={value.pk}>
                    <td
                      className={getDarkTableRow(themeContext)}
                    >{`${value.kd_keg} - ${value.nm_keg}`}</td>
                    <td
                      className={getDarkTableRow(themeContext)}
                    >{`${value.kd_akun} - ${value.nm_akun}`}</td>
                    <td className={getDarkTableRow(themeContext)}>
                      {" "}
                      <Badge
                        color={
                          selectedRealokasi.is_target === "t"
                            ? "success"
                            : "danger"
                        }
                        pill
                      >{`${formatRP(value.anggaran_tersisa)}`}</Badge>
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      <Badge
                        color={
                          selectedRealokasi.is_target === "t"
                            ? "success"
                            : "danger"
                        }
                        pill
                      >
                        {formatRP(getAnggaranDigunakan(value.pk))}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {/* {canAccessWhenStatusNot(
          selectedRealokasi.id_status_realokasi,
          STATUS_DATA_TYPE.Realokasi,
          [Diterima]
        ) ? (
          <Link
            to={`${process.env.PUBLIC_URL}/realokasi/edit/${selectedRealokasi.id}`}
          >
            <Button
              color="secondary"
              onClick={() => {
                toggle();
              }}
            >
              Ubah
            </Button>
          </Link>
        ) : null} */}
        <Button
          color="secondary"
          onClick={() => {
            toggle();
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RincianRealokasi;
